import { render } from "./ValueIndicators.vue?vue&type=template&id=6d504eb6&scoped=true"
import script from "./ValueIndicators.vue?vue&type=script&lang=js"
export * from "./ValueIndicators.vue?vue&type=script&lang=js"

import "./ValueIndicators.vue?vue&type=style&index=0&id=6d504eb6&lang=scss&scoped=true"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d504eb6"]])

export default __exports__